// HEAL-46a §6.4 — строка-вход, подключённая к данным.
//
// Живёт отдельно от самой строки, чтобы та осталась чистой и проверяемой без
// запросов. Здесь — только «сколько ждёт» и «куда вести».
//
// Куда вести: если все непроверенные из одного пакета — в пакет; иначе прямо в
// проверку конкретного анализа. Второе — случай человека, который грузил по
// одному, и пакета у него нет вовсе.

import { useUploadHistory } from '@/api/hooks/uploads';
import { PendingReviewBar } from '@/components/uploads/PendingReviewBar';
import { setReviewOrigin, setUploadsOrigin, UPLOADS_SECTION } from '@/lib/uploadNav';

export function PendingReviewBarContainer() {
  const awaiting = useUploadHistory({ status: 'awaiting_user_review' });
  const processing = useUploadHistory({ status: 'processing' });

  const awaitingItems = awaiting.data?.data ?? [];
  const processingItems = processing.data?.data ?? [];

  if (awaitingItems.length === 0 && processingItems.length === 0) return null;

  return (
    <PendingReviewBar
      awaitingCount={awaiting.data?.meta?.total ?? awaitingItems.length}
      processingCount={processing.data?.meta?.total ?? processingItems.length}
      href={hrefFor(awaitingItems, processingItems)}
      // Признак «откуда пришёл» ставится ПО КЛИКУ, а не при расчёте адреса
      // (круг ревью, находка 3). В теле рендера он переписывался бы на каждой
      // перерисовке Главной — обновление по фокусу, смена состояния, двойной
      // рендер в разработке — и затирал бы признак, выставленный другим экраном.
      // Этот же приём уже отвергали во втором круге ревью по HEAL-46.
      onNavigate={() => {
        if (awaitingItems.length > 0) setReviewOrigin('home');
        else setUploadsOrigin('home');
      }}
    />
  );
}

type Item = { id: number; batch_id: number | null };

/**
 * Куда вести: общий пакет — в пакет; разнобой или одиночки — в первый анализ,
 * ЖДУЩИЙ ПРОВЕРКИ.
 *
 * Последнее важно (круг ревью 2, находка 5): раньше при пустом списке ждущих
 * ссылка вела на первый обрабатываемый анализ, а экран проверки на нём
 * показывает «не удалось загрузить распознанные данные» — распознавать ещё
 * нечего. Пока проверять нечего, строка ведёт в пакет или, если пакета нет,
 * в историю загрузок.
 */
export function hrefFor(awaiting: Item[], processing: Item[]): string {
  const all = [...awaiting, ...processing];
  if (all.length === 0) return '/';

  const batchIds = new Set(all.map((i) => i.batch_id));
  const [only] = [...batchIds];

  if (batchIds.size === 1 && only !== null) {
    return `/uploads/batch/${only}`;
  }

  if (awaiting.length > 0) {
    return `/uploads/${awaiting[0].id}/review`;
  }

  // В историю ведём только когда проверять нечего.
  return UPLOADS_SECTION;
}
